import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=56eb2713&scoped=true"
import script from "./modal.vue?vue&type=script&lang=ts"
export * from "./modal.vue?vue&type=script&lang=ts"
import style0 from "./modal.vue?vue&type=style&index=0&id=56eb2713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eb2713",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonModal: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/modal.vue').default})
